import Divider from "@mui/material/Divider";
import * as React from "react";
import { Box, Grid } from "@mui/material";
import CharComboField from "./CharComboField";

export default function CharacterSetForm({ control, watch, program, isNewProgram, setValue, getValues }) {
  return (
    <Box sx={{ width: '100%' }}>
      <Grid container spacing={2} alignItems="stretch">
        <Grid item xs={4}>
          <CharComboField
            control={control}
            name={`codeDescriptor.characterSet.numbers`}
            disabled={!isNewProgram && program.availableReleaseCount !== 0}
            getValues={getValues}
          />
        </Grid>
        <Grid item sx={{ display: 'flex', alignItems: 'stretch' }}>
          <Divider orientation="vertical" flexItem />
        </Grid>
        <Grid item xs={4}>
          <CharComboField
            control={control}
            name={`codeDescriptor.characterSet.lowerCaseAlphabets`}
            disabled={!isNewProgram && program.availableReleaseCount !== 0}
            getValues={getValues}
          />
        </Grid>
        <Grid item sx={{ display: 'flex', alignItems: 'stretch' }}>
          <Divider orientation="vertical" flexItem />
        </Grid>
        <Grid item xs={4}>
          <CharComboField
            control={control}
            name={`codeDescriptor.characterSet.upperCaseAlphabets`}
            disabled={!isNewProgram && program.availableReleaseCount !== 0}
            getValues={getValues}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
